import { useCurrentSubscription } from 'features/subscription'
import { isProductEnabled } from 'helpers/subscription'
import { AppProduct } from 'models'

import { useSubscription } from './api/subscriptions'
import { useLDFlag } from './launchDarkly'
import { useIsLDContextStale } from './useLDContextStale'

export interface BotDetectionAccess {
  isLoading: boolean
  hasAccess: boolean
  hasAiApiAccess: boolean
  hasBrowserBotsAccess: boolean
}

/**
 * Determines what the current workspace can access on the Bot Detection page:
 * - AI API (Bots & AI agents events) while the free preview is on
 * - Browser bots when the Bot Detection product is enabled on the subscription
 */
export function useBotDetectionAccess(): BotDetectionAccess {
  const { currentSubscriptionId } = useCurrentSubscription()
  const { data: subscription, isLoading: isSubscriptionLoading } = useSubscription(currentSubscriptionId)
  const freePreviewEnabled = useLDFlag('AUTOMATION_INTELLIGENCE_API_FREE_PREVIEW', true)
  const isContextStale = useIsLDContextStale(currentSubscriptionId)

  const isLoading = isSubscriptionLoading || !subscription || isContextStale

  if (isLoading) {
    return {
      isLoading,
      hasAccess: false,
      hasAiApiAccess: false,
      hasBrowserBotsAccess: false,
    }
  }

  const hasAiApiAccess = freePreviewEnabled
  const hasBrowserBotsAccess = isProductEnabled(subscription, AppProduct.Botd)

  return {
    isLoading,
    hasAccess: hasAiApiAccess || hasBrowserBotsAccess,
    hasAiApiAccess,
    hasBrowserBotsAccess,
  }
}
